export default __webpack_public_path__ + "static/media/Asset-5.27269fc6.png";